import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "shell padding30px" }
const _hoisted_2 = { style: {"white-space":"nowrap"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" (")
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { style: {"color":"#8a8a8a"} }, "非厦门号码请在前面加0，比如 013899998888", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadHeaders }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        "label-position": _ctx.$formLabelPosition,
        ref: "formEle",
        model: _ctx.formData,
        rules: _ctx.rules,
        class: "set-page-form-width"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.DeviceDetailDetailUnitName,
            prop: "Build"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.Build,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.Build = $event)),
                disabled: !!_ctx.id,
                width: "300px"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item,
                      value: item.key,
                      label: item.value
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.RDeviceSearchLabelRoomName,
            prop: "Room"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.Room,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.Room = $event)),
                disabled: !!_ctx.id,
                filter: "",
                width: "300px"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.copyAptOption, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item,
                      value: item.key,
                      label: item.value
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.RDeviceSearchLabelRoomNumber,
            prop: "RoomNumber"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.RoomNumber,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.RoomNumber = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelPropertyManageEmail,
            prop: "Email"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Email,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.Email = $event)),
                disabled: _ctx.formData.IsMulti === 1
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelPropertyManageFirstName,
            prop: "FirstName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.FirstName,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.FirstName = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelPropertyManageLastName,
            prop: "LastName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.LastName,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.LastName = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextCountryRegion
          }, {
            default: _withCtx(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.PhoneCode,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.PhoneCode = $event)),
                disabled: _ctx.isCNServer,
                filter: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPhoneCodeOps(), (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item,
                      value: item.value,
                      label: item.label
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextMobileNumber,
            prop: "MobileNumber"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.MobileNumber,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.MobileNumber = $event)),
                onInput: _ctx.limitMobileNumberType,
                disabled: _ctx.formData.IsMulti === 1
              }, null, 8, ["modelValue", "onInput", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.isEnableLandline === 1)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode("label", _hoisted_2, [
                      _createTextVNode(_toDisplayString(_ctx.$wordList.FirstLandline) + " ", 1),
                      (_ctx.isCNServer)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _hoisted_3,
                            _hoisted_4,
                            _hoisted_5
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_6,
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.Phone,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.Phone = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.SecondLandline
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.Phone2,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formData.Phone2 = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.ThirdLandline
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.Phone3,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.Phone3 = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextCallType
          }, {
            default: _withCtx(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.PhoneState,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formData.PhoneState = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.callTypeOption, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item.value,
                      value: item.value,
                      label: item.label
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextSipIpCall
          }, {
            default: _withCtx(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.EnableIpDirect,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formData.EnableIpDirect = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sipCallOption, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item.value,
                      value: item.value,
                      label: item.label
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.formData.TempKeyPermission,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formData.TempKeyPermission = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextAllowedCreateQRCodes), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_cus_button, { onClick: _ctx.submit }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              (_ctx.id)
                ? (_openBlock(), _createBlock(_component_cus_button, {
                    key: 0,
                    class: "margin-left50px",
                    onClick: _ctx.reset,
                    disabled: _ctx.isDisabledReset
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$wordList.TabelResetPwTitle), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label-position", "model", "rules"])
    ])
  ]))
}